import React from 'react'
import {useTranslation} from 'react-i18next'

import {Box} from '@mui/material'

import {BankAccountDetailsType} from '@progyny/generated/graphql'
import BeneficiaryAccount from '@progyny/pages/Budget/Reimbursement/BeneficiaryAccount'
import {PaymentFormValues} from '@progyny/pages/Budget/Reimbursement/helpers/PaymentFormModel'
import {SubpageOneColGrid} from '@progyny/pages/Profile/fragments/grid'

export function normalizeBankDetails(
  raw: BankAccountDetailsType
): Partial<PaymentFormValues> {
  const base: Partial<PaymentFormValues> = {
    country: typeof raw.country === 'object' ? raw.country.code : raw.country,
    accountHolderName: raw.accountHolderName,
    accountNumber: raw.accountNumber,
    swiftCode: raw.swiftCode ?? '',
    bankName: raw.bankName,
  }
  if (raw.accountType) {
    base.accountType = raw.accountType.toLowerCase()
  }
  if (raw.localFields) {
    base.localFields = raw.localFields
  }
  return base
}

const BankDetails: React.FC = () => {
  const {t} = useTranslation()

  return (
    <Box mb={10} mt={{xs: 10, md: 15}}>
      <SubpageOneColGrid title={t('profile_payment_information')} lgSize={12}>
        <BeneficiaryAccount />
      </SubpageOneColGrid>
    </Box>
  )
}

export default BankDetails
